import "./Home.scss";

import Event from "./components/Event";
import { GlitchImage, GlitchText } from "./components/Glitch";
import Button from "./components/Button";
import Header from "./components/Header";

import cseLogo from "./assets/cse logo.webp";
import vyvidhLogo from "./assets/vyvidh.webp";
import vastLogo from "./assets/vast.webp";
import ozoneLogo from "./assets/ozone.webp";
import dtd from "./assets/events/dtd.webp";

import codex from "./assets/events/codex.webp";
import nft from "./assets/events/nft.webp";
import semicolon from "./assets/events/semicolon.webp";
import valorant from "./assets/events/valorant.webp";
import minigames from "./assets/events/minigames.webp";
import mazerunner from "./assets/events/mazerunner.webp";
import transylvania from "./assets/events/transylvania.webp";
import infinity from "./assets/events/infinity.webp";
import quiz from "./assets/events/quiz.webp";
import treasure from "./assets/events/treasure.webp";

const Home = () => (
	<div className="home">
		<div className="bodyBg"></div>
		<div className="bodyBg bodyBg2"></div>
		<div className="bodyBg bodyBg3"></div>
		<Header />

		<aside>
			<span className="timing">
				<GlitchText>
					29<sup>th</sup> &amp; 30<sup>th</sup> April
				</GlitchText>
				<GlitchText small>@ VAST Thrissur</GlitchText>
			</span>
		</aside>
		<section className="body">
			<div className="bodyBg"></div>
			<div className="bodyBg bodyBg2"></div>
			<div className="bodyBg bodyBg3"></div>
			<div className="content fixYSkew">
				<div className="associations">
					<span className="entity cse">
						<GlitchImage image={cseLogo} className="cseLogo" alt="cse logo" />
						<GlitchText>Dept. of CSE</GlitchText>
					</span>
					<h4>In Association With</h4>
					<div className="row">
						<span className="entity vast">
							<GlitchImage
								image={vastLogo}
								className="vastLogo"
								alt="vidya academy logo"
							/>
						</span>
						<span className="entity vast">
							<GlitchText>Vidya academy</GlitchText>
							<span className="small">
								<GlitchText>of science and technology</GlitchText>
							</span>
						</span>
						<span className="entity vyvidh">
							<GlitchImage
								image={vyvidhLogo}
								className="vyvidhLogo"
								alt="vyvidh logo"
							/>
						</span>

						<span className="entity vyvidh">
							<GlitchText>Vyvidh 22</GlitchText>
							<span className="small">
								<GlitchText>Techno Cultural Fest</GlitchText>
							</span>
						</span>
					</div>
					<h4>Presents</h4>
				</div>
			</div>
		</section>

		<section className="dtd events">
			<Event title="dtd" image={dtd} zoom="zoom" details="/events/dtd"></Event>
		</section>
		<aside>
			<GlitchText>SCREAM</GlitchText>
		</aside>

		<section className="body">
			<div className="content fixYSkew">
				<div className="associations ozone">
					<h4>Our Official Technical Partner</h4>
					<span className="entity ozone">
						<GlitchImage image={ozoneLogo} className="ozoneLogo" />
						<GlitchText>OZONE Car Spa and Detailing</GlitchText>
					</span>
				</div>
			</div>
		</section>

		<section className="technical events">
			<Event title="codex" image={codex} details="/events/codex"></Event>
			<Event
				title="semicolon"
				image={semicolon}
				details="/events/semicolon"
			></Event>
			<Event title="nft" image={nft} details="/events/nft"></Event>
		</section>
		<aside>
			<GlitchText>WORK</GlitchText>
		</aside>

		<section className="gaming events">
			<Event
				title="valorant"
				image={valorant}
				details="/events/respawn"
			></Event>
			<Event
				title="minigames"
				image={minigames}
				details="/events/minigames"
			></Event>
		</section>
		<aside>
			<GlitchText>PLAY</GlitchText>
		</aside>

		<section className="realgames events">
			<Event
				title="mazerunner"
				image={mazerunner}
				details="/events/mazerunner"
			></Event>
			<Event
				title="transylvania"
				image={transylvania}
				details="/events/transylvania"
			></Event>
		</section>
		<aside>
			<GlitchText>REVEL</GlitchText>
		</aside>

		<section className="trivial events">
			<Event title="quiz" image={quiz} details="/events/quiz"></Event>
			<Event
				title="infinity"
				image={infinity}
				details="/events/infinity"
			></Event>
			<Event
				title="treasure"
				image={treasure}
				details="/events/treasure"
			></Event>
		</section>
		<aside>
			<GlitchText>AND MORE</GlitchText>
		</aside>

		<section className="tb">
			<Event title="reel" zoom="zoom" link>
				<h4>DTD 2020 THROWBACK</h4>
				<Button
					href="https://www.youtube.com/watch?v=Pfy6zs50A5c"
					target="_blank"
				>
					Watch Reel
				</Button>
			</Event>
		</section>
	</div>
);
export default Home;
